'use client'

import { PropsWithChildren, useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'

import i18n from '@/utils/i18n'
import { defaultLocale, getAPILocaleFromLocale } from '@/utils/locale'

interface I18nProviderProps extends PropsWithChildren {
  locale?: string
}

const I18nAppProvider = ({ children, locale = defaultLocale }: I18nProviderProps) => {
  useEffect(() => {
    const language = getAPILocaleFromLocale(locale)
    if (i18n.language !== language) {
      i18n.changeLanguage(language)
    }
  }, [locale])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}

export default I18nAppProvider
